import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import API from "../../Service/Baseservice";
import { useLocation } from "react-router-dom";
const EligibilityCandidateView = () => {
    const { id } = useParams();
    const navigate = useNavigate();
    const location = useLocation();
    const pageNumber = location.state?.pageNumber || 1;
    const [data, setData] = useState({});
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        API.post("view_checkeligibilityform/condition", {
            checkeligibilityform_id: id
        })
            .then((res) => {
                const row = res.data?.data || {};
                setData(row);
            })
            .catch((err) => console.error("Error fetching candidate:", err))
            .finally(() => setLoading(false));
    }, [id]);

    if (loading) {
        return <div className="loader">Loading...</div>;
    }

    return (
        <div className="admin-form-container">

            <div className="newsadd-header">
                <h2 className="newsadd-title">View Candidate</h2>
                <div className="header-buttons">
                    <button onClick={() => navigate("/eligibilitycandidate", { state: { pageNumber } })} className="cancel-btn ">
                        Back
                    </button>
                </div>
            </div>

            <form className="admin-form-page">

                {/* Row 1 */}
                <div className="admin-form-row">
                    <div className="admin-form-group">
                        <label>Name</label>
                        <input type="text" value={data.name || ""} readOnly />
                    </div>

                    <div className="admin-form-group">
                        <label>Email</label>
                        <input type="email" value={data.email || ""} readOnly />
                    </div>
                </div>

                {/* Row 2 */}
                <div className="admin-form-row">
                    <div className="admin-form-group">
                        <label>Phone Number</label>
                        <input type="text" value={data.phone_number || ""} readOnly />
                    </div>
                    <div className="admin-form-group">
                        <label>Highest Education</label>
                        <input type="text" value={data.highestEducation || ""} readOnly />
                    </div>

                </div>

                {/* Row 3 */}
                <div className="admin-form-row">

                    <div className="admin-form-group">
                        <label>Job Experience</label>
                        <input type="text" value={data.jobExperience || ""} readOnly />
                    </div>
                    <div className="admin-form-group">
                        <label>First Language Rating</label>
                        <input type="text" value={data.firstLanguageRating || "--"} readOnly />
                    </div>
                </div>

                {/* Row 4 */}
                <div className="admin-form-row">


                    <div className="admin-form-group">
                        <label>Second Language Rating</label>
                        <input type="text" value={data.secondLanguageRating || "--"} readOnly />
                    </div>
                    <div className="admin-form-group">
                        <label>Age Factor</label>
                        <input type="text" value={data.ageFactor || "--"} readOnly />
                    </div>

                </div>

                {/* Row 5 */}
                <div className="admin-form-row">

                    <div className="admin-form-group">
                        <label>Valid job offer</label>
                        <input type="text" value={data.validJobOffer || "--"} readOnly />
                    </div>
                    <div className="admin-form-group">
                        <label>Adaptability Factors</label>
                        <input type="text" value={data.adaptabilityFactors || "--"} readOnly />
                    </div>
                </div>

                {/* Row 6 */}
                <div className="admin-form-row">
                    <div className="admin-form-group">
                        <label>Total Points</label>
                        <input type="text" value={data.totalPoints || 0} readOnly />
                    </div>
                </div>

            </form>
        </div>
    );
};

export default EligibilityCandidateView;
